// ── itemCategory.js — 식재료 신선/공산/소모 자동 분류 ──────────
// 식재료 이름에서 키워드로 신선식품 / 공산품 / 소모품 판단.
// 발주서 그룹핑·재고 분석에서 사용.
//
// 분류:
//   - 'fresh'      신선식품 (야채·과일·육류·수산·두부·계란·유제품)
//   - 'industrial' 공산품 (가공식품·소스·면·통조림·음료)
//   - 'supplies'   소모품 (비닐·세제·장갑·포일·일회용기 등 식재료 아님)
//   - 'semi'       반제품 (사용자가 직접 만든 소스/육수 등)
//   - 'other'      기타 (분류 불확실)

// ── 소모품 키워드 (식재료 아님 — 발주서엔 들어가도 식재료 집계엔 빠짐) ──
const SUPPLIES_KEYWORDS = [
  // 포장재
  '김밥지', '김밥용지', '쿠킹호일', '호일', '랩', '비닐',
  '봉투', '비닐봉투', '쇼핑백', '지퍼백', '위생백',
  '일회용', '용기', '도시락통', '컵', '종이컵', '플라스틱컵',
  '스푼', '포크', '나무젓가락', '젓가락', '빨대',
  '키친타올', '냅킨', '티슈', '물티슈',
  '프랩', '프렙',
  // 세제·청소
  '세제', '주방세제', '수세미', '고무장갑', '비닐장갑', '위생장갑',
  '행주', '청소', '락스', '소독', '세정', '세척', '클리너', '왁스',
  // 위생·소모
  '마스크', '캡', '위생모', '앞치마', '슈즈커버',
  '쓰레기봉투', '쓰레기봉지',
  '스티커', '라벨', '바코드',
];

// ── 신선식품 키워드 ─────────────────────────────────────────────
const FRESH_KEYWORDS = [
  // 야채·과일
  '양파', '마늘', '대파', '쪽파', '실파', '파',
  '양배추', '배추', '얼갈이', '무', '당근', '시금치', '부추', '상추', '깻잎',
  '호박', '애호박', '단호박', '가지', '고추', '풋고추', '청양', '꽈리',
  '감자', '고구마', '오이', '토마토', '방울토마토', '파프리카', '피망',
  '버섯', '표고', '새송이', '느타리', '팽이', '양송이',
  '콩나물', '숙주', '생강', '미나리', '셀러리', '브로콜리',
  '사과', '배', '귤', '오렌지', '레몬', '딸기', '바나나', '포도', '복숭아',
  '수박', '참외', '키위', '망고', '파인애플', '체리', '블루베리',
  '매실', '대추', '곶감', '연근', '도라지', '더덕', '죽순',

  // 육류
  '소고기', '한우', '국내산소', '수입소', '등심', '안심', '갈비', '양지', '차돌',
  '돼지고기', '삼겹', '목살', '항정', '뒷다리', '앞다리', '대패',
  '닭', '닭고기', '계육', '닭다리', '닭가슴', '닭날개', '닭봉', '닭똥집',
  '오리', '오리훈제', '양고기',

  // 수산물
  '생선', '고등어', '갈치', '명태', '동태', '코다리', '아귀', '대구',
  '오징어', '낙지', '주꾸미', '문어',
  '새우', '왕새우', '대하', '꽃게', '대게',
  '조개', '바지락', '홍합', '굴', '전복', '소라', '소라', '키조개',
  '멸치', '디포리', '북어', '황태',
  '김', '미역', '다시마', '톳', '파래', '꼬시래기', '매생이',
  '해삼', '멍게', '성게', '굴비',
  '연어', '참치회', '광어', '우럭', '도미', '방어',

  // 두부·계란·유제품
  '두부', '연두부', '순두부', '유부', '비지',
  '계란', '달걀', '메추리알', '오리알',
  '우유', '생크림', '치즈', '버터', '요거트', '요구르트',

  // 곡류·신선상태
  '쌀', '잡곡', '현미', '찹쌀', '보리', '메밀', '귀리', '서리태',
];

// ── 공산품 키워드 ───────────────────────────────────────────────
const INDUSTRIAL_KEYWORDS = [
  // 가공식품
  '햄', '소시지', '베이컨', '비엔나', '맛살',
  '어묵', '오뎅', '소세지',
  '만두', '교자',
  '냉동', '냉동식품', '튀김',

  // 면류
  '라면', '면', '우동', '소면', '중면', '쫄면', '냉면',
  '짜장', '스파게티', '파스타',
  '떡국떡', '떡볶이떡', '가래떡', '절편',
  '당면',

  // 소스·조미료
  '간장', '진간장', '국간장', '양조간장', '왜간장',
  '식초', '사과식초', '현미식초', '쌀식초',
  '설탕', '백설탕', '황설탕', '흑설탕', '슈가', '슈거', '꿀', '올리고당', '물엿',
  '소금', '굵은소금', '꽃소금', '천일염',
  '후추', '후추가루', '통후추',
  '고추장', '쌈장', '된장', '청국장',
  '고춧가루', '고추가루',
  '케찹', '케첩', '마요네즈', '머스타드', '핫소스',
  '식용유', '대두유', '카놀라', '해바라기', '포도씨', '옥수수기름',
  '참기름', '들기름', '올리브', '버진',
  '미원', '다시다', '치킨스톡', '다시팩', '맛소금', '미향', '한식조미',
  '향신료', '월계수', '카레', '강황', '큐민', '바질', '오레가노', '로즈마리',

  // 통조림·병조림
  '참치캔', '캔참치', '꽁치캔', '황도', '백도', '믹스넛', '캔커피',
  '잼', '딸기잼', '오렌지잼',

  // 음료
  '콜라', '사이다', '환타', '주스', '오렌지주스', '사과주스',
  '맥주', '소주', '막걸리', '청주', '와인',
  '생수', '미네랄', '아이스티', '커피믹스', '아메리카노',
  '음료', '탄산',

  // 기타 가공
  '견과', '아몬드', '땅콩', '호두', '캐슈', '피칸',
  '시리얼', '뮤즐리', '오트밀',
  '과자', '쿠키', '비스킷', '크래커', '초콜릿', '사탕',
  '빵', '식빵', '바게트', '버거번', '햄버거번',
  '분말', '믹스', '베이킹파우더', '베이킹소다', '효모', '이스트',
  '전분', '밀가루', '강력분', '중력분', '박력분', '튀김가루', '빵가루', '카레가루',
];

// ── 정규화: 공백·특수문자 제거, 소문자
function normalize(name) {
  return String(name || '')
    .toLowerCase()
    .replace(/[\s_\-(){}\[\]·,./]/g, '');
}

// ── 키워드 매칭 (부분 포함)
function matchAny(haystack, keywords) {
  const h = normalize(haystack);
  if (!h) return false;
  for (const kw of keywords) {
    const k = normalize(kw);
    if (k.length < 2) continue;
    if (h.includes(k)) return true;
  }
  return false;
}

// ── 명시적 카테고리 → 내부 키 매핑
// 사용자가 단가표에서 직접 선택한 카테고리 또는 OCR/import 시 부여된 값을 우선 인식.
const EXPLICIT_MAP = {
  // 신선식품
  'fresh': 'fresh', '신선': 'fresh', '신선식품': 'fresh',
  // 공산품
  'industrial': 'industrial', '공산': 'industrial', '공산품': 'industrial',
  // 소모품
  'supplies': 'supplies', '소모': 'supplies', '소모품': 'supplies', '비식자재': 'supplies',
  // 반제품
  'semi': 'semi', '반제품': 'semi',
  // legacy
  '원재료': '',   // 원재료는 명시 분류로 인정하지 않음 — 키워드 추론으로 넘어감
};

// ── 메인: 분류 결과 반환
// 우선순위:
//   1) 명시적 카테고리 ('소모품' 같은 사용자 지정)
//   2) 소모품 키워드 (식재료가 아님 — 음식 키워드보다 먼저)
//   3) 공산품 키워드
//   4) 신선식품 키워드
//   5) other
export function classifyItem(item) {
  if (!item) return 'other';
  const name = typeof item === 'string' ? item : (item.name || '');
  if (!name) return 'other';

  // 1) 명시적 카테고리/태그 우선
  if (typeof item === 'object') {
    const explicit = String(item.itemCategory || item.subCategory || item.category || '').toLowerCase();
    const mapped = EXPLICIT_MAP[explicit];
    if (mapped) return mapped;  // 빈 문자열('')은 추론으로 넘김
  }

  // 2) 소모품 우선 (비닐·세제 → 공산품 키워드와 겹치는 케이스가 있어 supplies 먼저)
  if (matchAny(name, SUPPLIES_KEYWORDS)) return 'supplies';

  // 3) 공산품 (가공품 우선 처리)
  if (matchAny(name, INDUSTRIAL_KEYWORDS)) return 'industrial';

  // 4) 신선식품
  if (matchAny(name, FRESH_KEYWORDS)) return 'fresh';

  return 'other';
}

// ── 내부 키 → 한글 라벨 (Firestore 저장값으로 사용)
export const CATEGORY_KEY_TO_LABEL = {
  fresh: '신선식품',
  industrial: '공산품',
  supplies: '소모품',
  semi: '반제품',
  other: '미분류',
};

// ── 한글 라벨 → 내부 키
export const CATEGORY_LABEL_TO_KEY = {
  '신선식품': 'fresh',
  '공산품':   'industrial',
  '소모품':   'supplies',
  '반제품':   'semi',
  '미분류':   'other',
};

// ── 분류 메타 ─────────────────────────────────────────────────
export const CATEGORY_META = {
  fresh: {
    key: 'fresh',
    label: '신선식품',
    color: '#1A56A0',
    bg: '#F4F7FB',
    desc: '야채·과일·육류·수산·두부·계란·유제품',
  },
  industrial: {
    key: 'industrial',
    label: '공산품',
    color: '#52525B',
    bg: '#FAFAFA',
    desc: '가공식품·소스·면·통조림·음료',
  },
  supplies: {
    key: 'supplies',
    label: '소모품',
    color: '#92400E',
    bg: '#FFFBEB',
    desc: '비닐·세제·장갑·일회용기 등 식재료 외',
  },
  semi: {
    key: 'semi',
    label: '반제품',
    color: '#7C2D12',
    bg: '#FEF3C7',
    desc: '매장에서 직접 만드는 소스·육수 등',
  },
  other: {
    key: 'other',
    label: '미분류',
    color: '#71717A',
    bg: '#F3F4F6',
    desc: '분류 미확정',
  },
};

// ── 그룹화 헬퍼: items[] → { fresh: [...], industrial: [...], supplies: [...], other: [...] }
export function groupByCategory(items) {
  const groups = { fresh: [], industrial: [], supplies: [], other: [] };
  for (const item of (items || [])) {
    const cat = classifyItem(item);
    // semi는 단가표 그룹화에서 제외 — 호출처에서 별도 처리
    if (cat === 'semi') continue;
    (groups[cat] || groups.other).push(item);
  }
  return groups;
}

// ── 순서 정렬 (신선 → 공산 → 소모 → 기타)
export const CATEGORY_ORDER = ['fresh', 'industrial', 'supplies', 'other'];
